import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {getCalendarInvite, setLoadingState, removeCalendarMessage} from '../actions';


class MeetingInvite extends Component {

	constructor(props){
		super(props);
		this.state = {calendar_invite:[]};
	}

	addToCalendar( meeting_id, ccode, series_id = 0, main_committee_code = '' ) {
		this.props.setLoadingState( meeting_id );
		if ( series_id !== 0 ) {
			this.props.getCalendarInvite( series_id, ccode, meeting_id, main_committee_code );
		} else {
			this.props.getCalendarInvite( meeting_id, ccode, meeting_id, main_committee_code );
		}
		this.updateCalendarState( this.props.meeting.ID, series_id );

	}

	updateCalendarState(meeting_id, series = 0,remove = false){
		const newState = this.state.calendar_invite;
		if(remove === false){
			let type = (series) ? ['series'] : ['occurrence'];

			if(typeof newState[meeting_id] === 'undefined'){
				newState[meeting_id] = type;
			} else{
				type = (series) ? 'series' : 'occurrence';
				newState[meeting_id].push(type);
			}
			this.setState({calendar_invite:newState});
		} else{
			let index = newState.indexOf(meeting_id);
			if(index > -1){
				newState.splice(index,1);
			}
			let newThis = this;
			setTimeout(function() {
				newThis.setState({calendar_invite:newState});
			},10000);
		}

	}

	getAddSeriesButton() {
		let meeting = this.props.meeting;
		return (<button
				className="calendar-invite committee-upcoming-meeting multi-calendar-invite series-invite"
				onClick={ this.addToCalendar.bind( this, meeting.ID, meeting.post_content, meeting.series, meeting.main_committee ) }
				data-meeting-id={ meeting.ID }
				data-ccode={ meeting.main_committee.CODE } type="button">
				<i aria-hidden="true" className="fa-regular fa-calendar"/> Add
				Series to Calendar
			</button>
		);
	}

	getAddMeetingButton() {
		let meeting = this.props.meeting;
		return (<button
				className="calendar-invite committee-upcoming-meeting single-meeting-invite"
				onClick={ this.addToCalendar.bind( this, meeting.ID, meeting.post_content, 0, meeting.main_committee ) }
				data-meeting-id={ meeting.ID }
				data-ccode={ meeting.main_committee.CODE } type="button">
				<i aria-hidden="true" className="fa-regular fa-calendar"/> Add
				Meeting to Calendar
			</button>
		);

	}

	getSuccessMessage(series = 0){
		let meeting = this.props.meeting;
		let inviteType = '';
		let meetingInviteSent = (typeof this.state.calendar_invite[meeting.ID] !== 'undefined');
		if(meetingInviteSent){
			inviteType = this.state.calendar_invite[meeting.ID];
		}
		if(!meetingInviteSent){
			if(series){
				return this.getAddSeriesButton();
			} else{
				return this.getAddMeetingButton();
			}

		} else{
			if(series){
				if(meetingInviteSent && inviteType.includes('series')) {
					return (<p className="calendar-invite committee-upcoming-meeting">
						<span aria-hidden="true" className="glyphicon glyphicon-check"/> Invite has been emailed.
					</p>);
				} else{
					return this.getAddSeriesButton();
				}
			} else{
				if(meetingInviteSent && inviteType.includes('occurrence') && !series ){
					return (<p className="calendar-invite committee-upcoming-meeting">
						<span aria-hidden="true" className="glyphicon glyphicon-check"/> Invite has been emailed.
					</p>);
				} else{
					return this.getAddMeetingButton();
				}
			}

		}
	}

	getMeetingInviteContent(){
		if(this.props.loadingState.includes(this.props.meeting.ID)){
			return (<img className="spinner" src={getAjaxLoader()}/>);
		}
		if(this.props.meeting.ID === this.props.meeting.series){
			return (this.getSuccessMessage(true));
		}
		//An occurrence of a series
		if(this.props.meeting.series !== 0 && (this.props.meeting.ID !== this.props.meeting.series)){

			return (<Fragment>
				{this.getSuccessMessage(true)}
				{this.getSuccessMessage()}
			</Fragment>);
		}
		if(this.props.meeting.series === 0){
			return this.getSuccessMessage()
		}
	}

	render(){
		const meeting = this.props.meeting;

		let calendarInvite = this.getMeetingInviteContent(meeting);
		if(meeting.type !== 'upcoming'){
			return(<div></div>);
		}
		return(
			<div className="meeting-invite-container">
				{calendarInvite}
			</div>
		);

	}

}


function mapStateToProps( {  meetings, myCommittees , calendarMessage, loadingState} ) {
	return {
		meetings , myCommittees, calendarMessage, loadingState
	};
}
export default connect(mapStateToProps,{getCalendarInvite, removeCalendarMessage, setLoadingState})(MeetingInvite);